import Http from '@/api/http.js'

export default {

  index() {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/remote_contacts`)
  },

  indexByModel({model, id}) {
    return Http.get(`${model}/${id}/remote_contacts`)
  },

  create(contact){
    return Http.post(`/remote_contacts`, {contact: {...contact}})
  },

  update(contact){
    return Http.put(`/remote_contacts/${contact.id}`, {
      contact: {...contact},
    });
  },

  show(id) {
    return Http.get(`/remote_contacts/${id}`);
  },

  delete(id){
    return Http.delete(`/remote_contacts/${id}`)
  }

}
